var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-rating',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('img',{attrs:{"width":"30","height":"30","src":require(`@/assets/images/${
                    props.isFilled ? 'ic30Star.svg' : 'ic30StarDark.svg'
                }`),"alt":""},on:{"click":props.click}})]}}])},'v-rating',{ ..._vm.$attrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }